import React from 'react';
import { MailOutlined } from '@ant-design/icons';
import AdnInput from '../adnInput/AdnInput'

const AdnEmail = ({ 
    addonBefore,
    addonAfter,
    readOnly,
    placeholder="Email",
    handleChange,
    handleBlur,
    validateTrigger,
    validationType,
    disabled
  }) => {
  return <div>
      <AdnInput
        name={"email"} 
        label={"Email"} 
        rules={validationType}
        prefix={<MailOutlined className="site-form-item-icon" />}
        type={"email"}
        placeholder={placeholder}
        maxLength={"50"}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        readOnly={readOnly || false}
        handleChange={handleChange}
        handleBlur={handleBlur}
        validateTrigger={validateTrigger}
        disabled={disabled}
      />
  </div>;
}

export default AdnEmail;
